import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-auto-rows: minmax(min-content, max-content);
  grid-gap: 12px;

  .top {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-gap: 12px;
    grid-auto-rows: max-content;
    align-items: center;
  }

  .home,
  .away {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 9px;
  }

  .middle {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 9px;
  }

  .home {
    justify-content: start;
  }

  .away {
    justify-content: grid-end;

    button {
      justify-self: end;
    }
  }

  .content {
    height: 131px;
  }

  .toolbar {
    margin-bottom: 7px;
    justify-content: space-between;

    &,
    .left {
      display: flex;
      align-items: center;
    }

    input {
      margin-right: 8px;
    }

    .important {
      margin-right: 20px;
    }
  }

  .actions {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 14px;
    margin-top: 8px;
  }
`;
